__turbopack_context__.v({
  "BannersSlider": "BannersSlider-module__PZEOeG__BannersSlider",
  "button": "BannersSlider-module__PZEOeG__button",
  "changer": "BannersSlider-module__PZEOeG__changer",
  "icon": "BannersSlider-module__PZEOeG__icon",
  "image": "BannersSlider-module__PZEOeG__image",
  "left": "BannersSlider-module__PZEOeG__left",
  "products": "BannersSlider-module__PZEOeG__products",
  "right": "BannersSlider-module__PZEOeG__right",
  "slider": "BannersSlider-module__PZEOeG__slider",
});
